import { render, staticRenderFns } from "./CRMCreateModal.vue?vue&type=template&id=05f3edfe&scoped=true"
import script from "./CRMCreateModal.vue?vue&type=script&lang=js"
export * from "./CRMCreateModal.vue?vue&type=script&lang=js"
import style0 from "./CRMCreateModal.vue?vue&type=style&index=0&id=05f3edfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f3edfe",
  null
  
)

export default component.exports